import { MODAL_TYPES } from "../utils/emitter";

// Единственный источник конфига зон. Раньше список был продублирован в Game.js
// (поле класса и setInitialState) и копии разъехались — теперь обе точки берут отсюда.
// ВАЖНО: фабрика, не константа — cards:[] мутируются заменой массива, начальные
// объекты нельзя шарить между «жизнями» стора.
export function createDefaultZones() {
  return [
    {
      modalType: MODAL_TYPES.ZONE_COMFORT_INSTRUCTION,
      isShowMore: false,
      key: "zoneComfort",
      title: "demo_result_test_page.zone_1.title",
      insight_form_title: "demo_result_test_page.zone_1.insight_form_title",
      from: "demo_result_test_page.from_to",
      cards: [],
      texts: [
        "demo_result_test_page.zone_1.text_1",
        "demo_result_test_page.zone_1.text_2",
        "demo_result_test_page.zone_1.text_3",
        "demo_result_test_page.zone_1.text_4",
      ],
      insight_form_texts: [
        "demo_result_test_page.zone_1.insight_form_text1",
        "demo_result_test_page.zone_1.insight_form_text2",
        "demo_result_test_page.zone_1.insight_form_text3",
      ],
      icon_name: "double_comfort_icon",
    },
    {
      modalType: MODAL_TYPES.ZONE_STUDY_INSTRUCTION,
      isShowMore: false,
      key: "zoneStudy",
      title: "demo_result_test_page.zone_6.title",
      insight_form_title: "demo_result_test_page.zone_6.insight_form_title",
      from: "demo_result_test_page.from_to",
      cards: [],
      texts: [
        "demo_result_test_page.zone_6.text_1",
        "demo_result_test_page.zone_6.text_2",
      ],
      insight_form_texts: [
        "demo_result_test_page.zone_6.insight_form_text1",
        "demo_result_test_page.zone_6.insight_form_text2",
        "demo_result_test_page.zone_6.insight_form_text3",
      ],
      icon_name: "double_study_icon",
    },
    {
      modalType: MODAL_TYPES.ZONE_AGREEMENT_INSTRUCTION,
      isShowMore: false,
      key: "zoneAgreement",
      title: "demo_result_test_page.zone_5.title",
      insight_form_title: "demo_result_test_page.zone_5.insight_form_title",
      from: "demo_result_test_page.from_to",
      cards: [],
      texts: [
        "demo_result_test_page.zone_5.text_1",
        "demo_result_test_page.zone_5.text_2",
        "demo_result_test_page.zone_5.text_3",
      ],
      insight_form_texts: [
        "demo_result_test_page.zone_5.insight_form_text1",
        "demo_result_test_page.zone_5.insight_form_text2",
        "demo_result_test_page.zone_5.insight_form_text3",
      ],
      icon_name: "double_agreement_icon",
    },
    {
      modalType: MODAL_TYPES.ZONE_INTEREST_INSTRUCTION,
      isShowMore: false,
      key: "zoneInterest",
      title: "demo_result_test_page.zone_2.title",
      insight_form_title: "demo_result_test_page.zone_2.insight_form_title",
      from: "demo_result_test_page.from_to",
      cards: [],
      texts: ["demo_result_test_page.zone_2.text_1"],
      insight_form_texts: [
        "demo_result_test_page.zone_2.insight_form_text1",
        "demo_result_test_page.zone_2.insight_form_text2",
        "demo_result_test_page.zone_2.insight_form_text3",
      ],
      icon_name: "double_interests_icon",
    },
    {
      modalType: MODAL_TYPES.ZONE_DIALOGUE_INSTRUCTION,
      isShowMore: false,
      key: "zoneDialog",
      title: "demo_result_test_page.zone_3.title",
      insight_form_title: "demo_result_test_page.zone_3.insight_form_title",
      from: "demo_result_test_page.from_to",
      cards: [],
      texts: ["demo_result_test_page.zone_3.text_1"],
      insight_form_texts: [
        "demo_result_test_page.zone_3.insight_form_text1",
        "demo_result_test_page.zone_3.insight_form_text2",
        "demo_result_test_page.zone_3.insight_form_text3",
      ],
      icon_name: "double_dialogue_icon",
    },
    {
      modalType: MODAL_TYPES.ZONE_CONTRADICTION_INSTRUCTION,
      isShowMore: false,
      key: "zoneContradiction",
      title: "demo_result_test_page.zone_4.title",
      insight_form_title: "demo_result_test_page.zone_4.insight_form_title",
      from: "demo_result_test_page.from_to",
      cards: [],
      texts: ["demo_result_test_page.zone_4.text_1"],
      insight_form_texts: [
        "demo_result_test_page.zone_4.insight_form_text1",
        "demo_result_test_page.zone_4.insight_form_text2",
      ],
      icon_name: "double_contradictions_icon",
    },
    // Этап 2: 7-я зона «Личные запросы» — заполненные индивидуальные (BLANK) анкеты;
    // рендерится особой веткой ZoneItem (kind: personal), cards = zonePersonal с бэка
    {
      // у 7-й зоны нет модалки-инструкции (ZonePersonal рендерит описание сам)
      isShowMore: false,
      key: "zonePersonal",
      kind: "personal",
      title: "demo_result_test_page.zone_7.title",
      insight_form_title: "demo_result_test_page.zone_7.title",
      from: "demo_result_test_page.from_to",
      cards: [],
      texts: [
        "demo_result_test_page.zone_7.text_1",
        "demo_result_test_page.zone_7.text_2",
        "demo_result_test_page.zone_7.text_3",
      ],
      insight_form_texts: [],
      icon_name: "double_comfort_icon",
    },
  ];
}
